import {
    useMemo,
} from 'react'
import noop from 'lodash/noop'

import useEnumValues from 'app/hooks/useEnumValues'
import FormWithControls from 'app/shared-components/FormWithControls'
import useFieldsWithClassName from 'app/hooks/useFieldsWithClassName'
import {
    LoggerConfiguration,
} from 'app/enums/label.enums'
import {
    DelayedLoadOptions,
} from 'app/hooks/useDelayedLoadOptions'
import loggerFormRequest from 'app/requests/LoggerPairing.requests'
import useLabel from 'app/hooks/useLabel'

import loggerComponents from './LoggerForm.fields'
import useStyles from './LoggerForm.styles'

import {
    LoggerFormContainerProps,
    LoggerValue,
} from './LoggerForm.types'

type Props = LoggerFormContainerProps & {
    value: LoggerValue,
    loadOptions?: (o: DelayedLoadOptions) => void,
    setExternalValue?: (value: LoggerValue) => void,
    loadLabel?: (id: number | string) => void,
}

const LoggerForm = ({
    loadOptions = noop,
    loadLabel = noop,
    value,
    serialNumber,
    onSuccess,
    setExternalValue = noop,
}: Readonly<Props>) => {
    const l = useLabel()
    const {
        classes,
    } = useStyles()
    const loggerLabels = useEnumValues()(LoggerConfiguration)

    const fields = useFieldsWithClassName(useMemo(() => {
        return loggerComponents({
            loadOptions,
            loadLabel,
            value,
            loggerLabels,
            l,
        })
    }, [
        loadOptions,
        loadLabel,
        value,
        loggerLabels,
        l,
    ]), classes)

    return (
        <div className={classes.container}>
            <FormWithControls
                name="LoggerInformationDto"
                setExternalValue={setExternalValue}
                value={value}
                fields={fields}
                classNames={{
                    gridWrapper: classes.gridWrapper,
                    gridCardWrapper: classes.gridCardWrapper,
                }}
                requestParams={loggerFormRequest.add({
                    serialNumber,
                })}
                onSuccess={onSuccess}
            />
        </div>
    )
}

export default LoggerForm
